import React, { FC } from "react";
import { Popper as MuiPopper } from "@mui/material";

type Props = React.ComponentProps<typeof MuiPopper>;

const Popper: FC<Props> = (props) => {
    return <MuiPopper {...props}/>
}

export default Popper;